import { useEffect, useRef, useState } from 'react';

export const useElementWidth = () => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [elementWidth, setElementWidth] = useState<number | undefined>(
    undefined
  );

  useEffect(() => {
    if (!elementRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        // Account for chart margins
        const containerWidth = entry.contentRect.width;
        const effectiveWidth = Math.max(containerWidth - 60, 0);
        setElementWidth(effectiveWidth);
      }
    });

    resizeObserver.observe(elementRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  return {
    elementRef,
    elementWidth,
  };
};
